//Helpers for multi-column table sorting. The ordering is kept as a comma
//separated string ("name,-age"), which is the format accepted by the API.

export const parseOrdering = (ordering) =>
  typeof ordering === "string"
    ? ordering
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean)
    : [];

const stringifyOrdering = (fields) => fields.join(",");

const stripDirection = (field) => (field.startsWith("-") ? field.slice(1) : field);

//Add the column to the sort list (ASC), or flip its direction if already present
export const toggleSort = (ordering, field) => {
  const fields = parseOrdering(ordering);
  const index = fields.findIndex((item) => stripDirection(item) === field);

  if (index === -1) return stringifyOrdering([...fields, field]);

  fields[index] = fields[index].startsWith("-") ? field : `-${field}`;
  return stringifyOrdering(fields);
};

//Remove only the given column from the sort list
export const removeSort = (ordering, field) =>
  stringifyOrdering(
    parseOrdering(ordering).filter((item) => stripDirection(item) !== field),
  );

//Direction ("asc" | "desc" | null), position (1-based) and total count of active sorts
export const getSortState = (ordering, field) => {
  const fields = parseOrdering(ordering);
  const index = fields.findIndex((item) => stripDirection(item) === field);

  if (index === -1) return { direction: null, position: null, total: fields.length };

  return {
    direction: fields[index].startsWith("-") ? "desc" : "asc",
    position: index + 1,
    total: fields.length,
  };
};
